
































































import { defineComponent, ref } from "@vue/composition-api";
import i18n from "@/plugins/i18n";
import useUser from "@/composables/user";
import firebase from "@/services/firebase";

const AFFILIATE_PORTAL_URL = "https://ellity-affiliate-admin.vercel.app/login";

export default defineComponent({
  setup(props, context) {
    const { logout, user } = useUser();
    const router = context.root.$router;
    const affiliateLoading = ref(false);
    const miniVariant = ref(true);

    const items = [
      {
        title: i18n.t("navigation.home"),
        icon: "fas fa-home",
        to: {
          name: "home",
        },
      },
      {
        title: i18n.t("navigation.businesses"),
        icon: "fas fa-users",
        to: {
          name: "businesses",
          params: {
            initBusinessState: 3,
          },
        },
      },
    ];

    if (user.value?.role != "dev") {
      items.push(
        ...[
          {
            title: i18n.t("navigation.tasks"),
            icon: "fas fa-tasks",
            to: {
              name: "tasks",
            },
          },
          {
            title: i18n.t("navigation.shoptet"),
            icon: "fas fa-edit",
            to: {
              name: "shoptet",
            },
          },
          {
            title: i18n.t("navigation.news"),
            icon: "fas fa-star",
            to: {
              name: "news",
            },
          },
        ]
      );
    }

    // items.push({
    //   title: i18n.t("navigation.map"),
    //   icon: "fas fa-map",
    //   to: {
    //     name: "map",
    //   },
    // });

    const signout = async () => {
      await logout();
      router.push({
        name: "login",
        params: { returnUrl: router.currentRoute.fullPath },
      });
    };

    const openAffiliatePortal = async () => {
      if (affiliateLoading.value) return;
      affiliateLoading.value = true;
      try {
        const token = await firebase.generateAffiliateToken();
        const url = `${AFFILIATE_PORTAL_URL}?token=${encodeURIComponent(token)}`;
        window.open(url, "_blank", "noopener,noreferrer");
      } catch (error) {
        console.error("Failed to generate affiliate token:", error);
      } finally {
        affiliateLoading.value = false;
      }
    };

    return {
      items,
      signout,
      affiliateLoading,
      openAffiliatePortal,
      miniVariant,
    };
  },
});
